import { render, staticRenderFns } from "./stuChangeCount.vue?vue&type=template&id=7d630294&scoped=true"
import script from "./stuChangeCount.vue?vue&type=script&lang=js"
export * from "./stuChangeCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d630294",
  null
  
)

export default component.exports